module.exports = __webpack_public_path__ + "static/media/left-chev-purple.641e7147.svg";